// eslint-disable-next-line no-control-regex
export const regex = /[\0-\x1F\x7F-\x9F]/;
